import { render, staticRenderFns } from "./FeaturesAccess.vue?vue&type=template&id=489dfe76&scoped=true&"
import script from "./FeaturesAccess.vue?vue&type=script&lang=js&"
export * from "./FeaturesAccess.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesAccess.vue?vue&type=style&index=0&id=489dfe76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489dfe76",
  null
  
)

export default component.exports